import React, { Component } from 'react';
import Constants from '../../game/constants/Constants';
import NavTools from '../../tools/NavTools';

export default class PauseButton extends Component {
    constructor(props) {
        super(props);
        this.gameCtx = props.gameCtx;
        this.pauseEvent = null;
        this.setPauseEvent();
    }

    setPauseEvent = () => {
        let res, rej;
        let promise = new Promise((resolve, reject) => {
            res = resolve; rej = reject;
        });
        promise.isDone = false;
        promise.resolve = res;
        promise.reject = rej;
        this.pauseEvent = promise;
    }

    resolvePauseEvent = (val) => {
        if (this.pauseEvent.isDone) { return }
        this.pauseEvent.resolve(val);
        this.pauseEvent.isDone = true;
    }

    pauseGameLogic = () => {

        for (let key in this.gameCtx.waitForPromises) { // we want to put inside a function, wivh will recive a cb
            this.gameCtx.waitForPromises[key].resolveTimer.pause()
        }
        this.gameCtx.movingCards.forEach(card => {
            let divOfCard = document.getElementById(card.ref.current.id)
            if (divOfCard !== undefined) {
                let currCardStyle = window.getComputedStyle(divOfCard)
                card.ref.current.settingPositionWhileGamePaused(
                    {
                        WebkitTransform: currCardStyle.webkitTransform,
                        MozTransform: currCardStyle.webkitTransform,
                        OTransform: currCardStyle.webkitTransform,
                        msTransform: currCardStyle.webkitTransform,
                        transiton: 'paused !important',
                        left: currCardStyle.left,
                        top: currCardStyle.top
                    }
                )
            }
        });
        //pause motion by overriding css transition --- todo
        this.gameCtx.gameStatus = Constants.GAME_STATUS_PAUSED;
        this.gameCtx.gameTimerRef.current.pauseTimer(); // todo: take care of when timer is restarting at the same second
        this.gameCtx.soundRepository.stopAllSounds();
        this.gameCtx.soundRepository.pauseSoundByName(Constants.SOUND_BACKGROUND);
    }

    pauseGame = async () => {
        this.pauseGameLogic();
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        let text = <div className="popup-text">המשחק הושהה!<br />האם תרצה להמשיך או לצאת מן המשחק?</div>
        let popupRes = await cEntity.addPopupWithEvent(text, "המשך", "יציאה");

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);

        if (popupRes) {
            this.gameCtx.soundRepository.resumeBackgroundMusic();
            await this.resumGame();
        }
        else {
            this.gameCtx.soundRepository.stopSoundByName(Constants.SOUND_BACKGROUND);
            this.exitGame();
        }
    }

    resumGame = () => {
        this.gameCtx.movingCards.forEach(card => {
            card.ref.current.settingPositionWhileGamePaused({})
        });
        // this.gameCtx.waitForPromises.forEach(event => event.resolveTimer.resume());

        for (let key in this.gameCtx.waitForPromises) { // we want to put inside a function, wivh will recive a cb
            this.gameCtx.waitForPromises[key].resolveTimer.resume()
        }
        this.gameCtx.movingCards = []
        this.gameCtx.gameStatus = Constants.GAME_STATUS_PLAYING;
        this.gameCtx.gameTimerRef.current.resumeTimer();
        this.resolvePauseEvent();
    }

    exitGame = () => {
        // this.gameCtx.waitForPromises.forEach(event => event.resolveTimer.pause());
        this.gameCtx.gameStatus = Constants.GAME_STATUS_ENDED;
        NavTools.redirect(this.gameCtx.props, "/");
    }

    render() {
        return (
            <img className="pause-btn"
                alt="pause-btn"
                src={require('../../media/images/icons/stop.png')}
                onClick={this.pauseGame} />
        );
    }
}